/*
 * Ein Rad pro Bestellung – Hinweis im Theme.
 * Mehrere verschiedene Räder dürfen in den Warenkorb; zur Kasse geht nur eins. Die verbindliche Sperre
 * liegt im Checkout (BSure Checkout Rules), den Hinweis zeigen Warenkorb und Drawer (Liquid).
 * - Produktseite: Formular mit data-cb-ein-rad="1" prüft vor dem Absenden, ob genau dieses Rad schon
 *   im Warenkorb liegt (/cart.js) – dann Hinweis statt Menge 2.
 * - Warenkorb und Drawer: Mengenfelder mit data-cb-rad-max werden auf höchstens 1 begrenzt.
 * Rad-Regel: snippets/cb-ist-rad.liquid (Nicht-Rad-Typen kommen als JSON aus #cb-ein-rad-typen).
 */
(function () {
  if (window.cbEinRad) return;
  window.cbEinRad = true;

  var TEXT_GLEICHES = 'Dieses Rad liegt schon in deinem Warenkorb. Jedes Rad gibt es nur einmal.';

  function keinRadTypen() {
    var el = document.getElementById('cb-ein-rad-typen');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  function istRad(item, typen) {
    if (item.gift_card) return false;
    var typ = String(item.product_type || '').toLowerCase().trim();
    return typen.indexOf(typ) === -1;
  }

  function zeige(form, text) {
    var box = form.querySelector('[data-cb-einrad-hinweis]');
    if (!box) { alert(text); return; }
    box.querySelector('.cb-einrad__text').textContent = text;
    box.hidden = false;
  }

  function absenden(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function cartUrl() {
    return ((window.theme && theme.routes && theme.routes.cart_url) || '/cart') + '.js';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-cb-ein-rad="1"]')) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var typen = keinRadTypen();
        var pid = Number(form.dataset.cbProdukt);
        var gleiches = (cart.items || []).some(function (item) {
          return item.product_id === pid && istRad(item, typen);
        });
        if (gleiches) {
          if (button) button.disabled = false;
          zeige(form, TEXT_GLEICHES);
          return;
        }
        absenden(form);
      })
      .catch(function () {
        // Warenkorb nicht lesbar: normal absenden, der Checkout prüft trotzdem.
        absenden(form);
      });
  }, true);

  function begrenze(e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[data-cb-rad-max]')) return;
    if (Number(input.value) > 1) input.value = 1;
  }
  document.addEventListener('input', begrenze, true);
  document.addEventListener('change', begrenze, true);
})();
